import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IApiResult } from '../shared/models/api-result';
import { PayCategory } from '../shared/models/pay-category';
import { ApiUrlProvider } from './api-url.provider';

@Injectable({
  providedIn: 'root'
})
export class PayCategoryService {
  constructor(private http: HttpClient, private apiUrlProvider: ApiUrlProvider) { }
  
  getAll(): Observable<IApiResult<PayCategory[]>>{
    return this.http.get<IApiResult<PayCategory[]>>(`${this.apiUrlProvider.url}/PayCategory`);
  }

  add(entity: PayCategory): Observable<IApiResult<PayCategory>>{
    return this.http.post<IApiResult<PayCategory>>(`${this.apiUrlProvider.url}/PayCategory`, entity);
  }

  update(entity: PayCategory): Observable<IApiResult<PayCategory>>{
    return this.http.post<IApiResult<PayCategory>>(`${this.apiUrlProvider.url}/PayCategory/${entity.id}`, entity);
  }

  delete(entityId: number): Observable<IApiResult<string>>{
    return this.http.post<IApiResult<string>>(`${this.apiUrlProvider.url}/PayCategory/${entityId}/delete`, null);
  }
}
